module.exports = __webpack_public_path__ + "img/icon_2_35.b1915f15.png";